<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                        <el-row>
                            <el-col>
                                <span class="cs-title">移动端广告管理</span>
                              <div class="cs-fullheight cs-pagination-container" style="margin-bottom:10px;">
                                <div class="cs-pagination-header">
                                  <el-button class="cs-pagination-header-add" v-on:click="add()"  type="primary" plain icon="el-icon-plus">添加广告</el-button>
                                </div>
                              </div>
                              <div class="cs-pagination-table-container">
                                       <el-col :span="6" class="block"  v-for="(ad,key,index) in advertistings" :key="index " style="padding-right:50px">

                                         <image-show center
                                            :src="ad.pictureUrl"  @click="onPriview(ad.pictureUrl)" style="height:160px;width:200px"
                                            :isVisible="true"
                                          ></image-show>

                                        <div class="bottom clearfix">
                                          <el-button type="text" class="button" v-on:click="onChange(ad)">{{ad.isActive?'可用':'不可用'}}</el-button>
                                          <el-button type="text" class="button" v-on:click="edit(index,ad)">修改</el-button>
                                          <el-button type="text" class="button" @click="onDelete(ad.id)">删除</el-button>
                                        </div>

                                    </el-col>
                              </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
      <adEdit :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess"></adEdit>
    </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import adList from "../../components/advertistings/adList";
import adEdit from "../../components/advertistings/adEdit";
import { getAdvertitings,deleteIt,enable,disable,edit } from "../../service/advertisting.service";
import imageShow from "@/components/fileHandler/imageShow";

export default {
  data() {
    return {
      loading: false,
      advertistings:[],
      editData:{},
      dialogEditorVisible: false,
    };
  },
  components: {
    navigator,
    adEdit,
    imageShow
  },
  computed: {},
  created() {
    this.getAll();
  },
  methods: {
    getAll(){
      this.loading=true;
      getAdvertitings().then(result=>
            {
              if (result && result.success) {
                this.advertistings=result.data;
                this.loading=false;
              }
      })
    },
    onChange(advertisting){
      if(advertisting.isActive){
        this.onDisable(advertisting);
      }else{
        this.onEnable(advertisting);
      }
    },
    onDisable(advertisting){
      this.loading=true;
      disable(advertisting.id).then(result=>{
        if(result && result.success){
          advertisting.isActive=false;
          this.loading=false;
        }
      })
    },
    onEnable(advertisting){
      this.loading=true;
      enable(advertisting.id).then(result=>{
        if(result && result.success){
          advertisting.isActive=true;
          this.loading=false;
        }
      })
    },
    onDelete(id){
      this.$confirm("您确认要删除该广告吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            deleteIt(id).then(result=>{
              this.getAll();
            });
      })
      .catch(() => {});

    },
    onCloseEditor(){
      this.dialogEditorVisible = false;

    },
    onSaveSuccess(isAdd, row){
      this.dialogEditorVisible = false;
      this.getAll();
    },
     add() {
      this.editData = {};
      this.dialogEditorVisible = true;
    },
    edit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    onPriview(pictureUrl){
      window.open(pictureUrl, "_blank");
    }
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/page/advertistings/advertistingList.vue